<li>
  <form [formGroup]="categoryForm">
    <sui-checkbox
      [checked]="category.is_selected"
      (checkedChange)="onCheckboxChange($event)"
    >
      {{ category.name }}
      <span class="selected-count" *ngIf="category.selected_count > 0">
        ({{ category.selected_count }})</span
      >
    </sui-checkbox>
  </form>
  <ul *ngIf="category.children && category.children.length">
    <app-category
      *ngFor="let child of category.children"
      [category]="child"
      [categoryForm]="categoryForm"
    ></app-category>
  </ul>
</li>
